import {isHybridEmbedded} from "./hybrid-utils";

function isHybridEmbeddedQA(): boolean {
    if(!isHybridEmbedded()) {
        return false;
    }

    if(window['isQAEnvironment']) {
        return window['isQAEnvironment']();
    }

    return false;
}

export function isOrbitInQAMode(): boolean {
    return Boolean(window['isOrbitWebAppInQAMode']) || isHybridEmbeddedQA();
}